import { render, staticRenderFns } from "./p-term-and-conditions.vue?vue&type=template&id=2d2490c5&"
import script from "./p-term-and-conditions.vue?vue&type=script&lang=js&"
export * from "./p-term-and-conditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports